module.exports = __webpack_public_path__ + "static/media/workout_card_bg.97cc788d.jpg";